import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";

const SVInvoiceReport = ({ filter, groupName }: { filter: any, groupName: string | null }) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [openSubModel, setOpenSubModel] = useState({ open: false, name: "", index: 0 } as { open: boolean, name: string, index: number });
  const [openSubModel2, setOpenSubModel2] = useState({ open: false, singleData: [] } as { open: boolean, singleData: any });
  const [subModelTableData, setSubModelTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ consultant_Name: string, fromDate: Date, toDate: Date }>; loading: boolean });
  const dt = useRef<any>(null);
  const dt2 = useRef<any>(null);
  const toast = useRef<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj.date_Format;

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Sub Vendor Invoice Report</h5>
    </div>
  );

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const mappedFilter = {
      FromDate: filter?.fromDate,
      ToDate: filter?.ToDate,
      Company_ID: filter?.company_ID ?? null,
      Group_ID: filter?.company_Group_ID ?? null,
    };
    const response = await Fetch("Report_Timesheet/getSVInvoiceAddedCount", "GET", null, `filter=${JSON.stringify(mappedFilter)}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  const openSubModalFunc = async (rowData: any) => {
    setOpenSubModel2({ open: true, singleData: rowData });
    setSubModelTableData({ tableData: rowData.consultants, loading: false });
  }

  useEffect(() => {
    loadTableData();
  }, [filter]);

  const isGroupWise = filter?.company_Type === "Company Group Wise";

  const headerGroup = (
    <ColumnGroup>
      {/* First header row */}
      <Row>
        <Column header="SN" rowSpan={1} />
        <Column header="Company & Consultant#" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} colSpan={2} />
        <Column header="Added Invoices" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} colSpan={2} />
        <Column header="Pending Invoices" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} colSpan={1} />
      </Row>

      {/* Second header row */}
      <Row>
        <Column header="" />

        <Column header="Company Name" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />
        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />

        <Column header="In House#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Subvendor#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />

        <Column header="Pending#" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} />
      </Row>
    </ColumnGroup>
  );

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
      </React.Fragment>
    );
  };

  const exportCSV2 = () => {
    dt2.current.exportCSV();
  };

  const rightToolbarTemplate2 = () => {
    return (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV2} />
      </React.Fragment>
    );
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} />
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        resizableColumns
        showGridlines
        columnResizeMode="expand"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        ref={dt}
        size="small"
        stripedRows
        scrollable
        scrollHeight="70vh"
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
        headerColumnGroup={headerGroup}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />

        {isGroupWise ? <Column field="company_Name" header={`Company Name of ${groupName || ""}`} headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} /> : <Column field="company_Name" header="Company" headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} />}
        <Column field="totalPOCount" header="No of PO" headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalPOCount || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />

        <Column field="addedByInHouse" header="No of SV Invoice Uploaded By  InHouse" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} body={(rowData: any, options: any) => <p className={(rowData.addedByInHouse > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedByInHouseList", index: options.rowIndex })}>{rowData.addedByInHouse}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedByInHouse || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="addedBySV" header="No of SV Invoice Uploaded By SV Account" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} body={(rowData: any, options: any) => <p className={(rowData.addedBySV > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedBySVList", index: options.rowIndex })}>{rowData.addedBySV}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedBySV || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />

        <Column field="totalInvoiceLeft" header="No of Pending SV Invoice" headerStyle={{ backgroundColor: "#f9f497" }} bodyStyle={{ backgroundColor: "#f9f497" }} footerStyle={{ backgroundColor: "#f9f497" }} body={(rowData: any) => <p className={rowData.totalInvoiceLeft > 0 ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => rowData.totalInvoiceLeft > 0 ? openSubModalFunc(rowData) : {}}>{rowData.totalInvoiceLeft}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalInvoiceLeft || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
      </DataTable>
      <Dialog visible={openSubModel.open} style={{ width: '80vw' }} header={<p>Sub Table</p>} modal className="p-fluid" onHide={() => setOpenSubModel({ open: false, name: "", index: 0 })}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          resizableColumns
          showGridlines
          columnResizeMode="expand"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          size="small"
          stripedRows
          scrollable
          scrollHeight="70vh"
          value={(tableData.tableData[openSubModel.index] || {})[openSubModel.name]}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="invoiceNO" header="#Invoice" />
          <Column field="consultant_Name" header="Consultant Name" />
          <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="workHours" header="Work Hours" body={(rowData: any) => <p>{Number(rowData.workHours || "0") + Number(rowData.overlapWorkHours || "0")}</p>} />
          <Column field="isVerfied" header="Status" />
          <Column field="paymentStatus" header="Payment Status" />
        </DataTable>
      </Dialog>
      <Dialog visible={openSubModel2.open} style={{ width: '80vw' }} header={<p>Sub Table</p>} modal className="p-fluid" onHide={() => setOpenSubModel2({ open: false, singleData: {} })}>
        <Toolbar className="mb-1 py-0" right={rightToolbarTemplate2} />
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          ref={dt2}
          resizableColumns
          showGridlines
          columnResizeMode="expand"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          size="small"
          stripedRows
          scrollable
          loading={subModelTableData.loading}
          scrollHeight="70vh"
          value={subModelTableData.tableData}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="consultant_Name" header="Consultant Name" />
          {/* <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, false)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, false)} /> */}
        </DataTable>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
};

export default SVInvoiceReport;
